import {createContext} from 'react';

export const PoiContext = createContext();